module.exports = __webpack_public_path__ + "img/DNA-Logo.b5c87208.png";